import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { ValuationAgentPermissionSchema } from '../admin/valuation-agent-token.schemas';

/**
 * Bus events for the valuation agent's token (IMM-1402). Ids and the granted permission set only:
 * never the secret, never its hash.
 */
export const ValuationAgentTokenIssuedPayloadSchema = z.object({
  tokenId: z.uuid(),
  permissions: z.array(ValuationAgentPermissionSchema),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type ValuationAgentTokenIssuedPayload = z.infer<typeof ValuationAgentTokenIssuedPayloadSchema>;

/** Every token ended by one revoke: the active one first, then a replaced one still within its overlap. */
export const ValuationAgentTokenRevokedPayloadSchema = z.object({
  tokenIds: z.array(z.uuid()).min(1),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type ValuationAgentTokenRevokedPayload = z.infer<typeof ValuationAgentTokenRevokedPayloadSchema>;

/** One rotation: the new token, the one it replaced, and an earlier overlap token it ended (if any). */
export const ValuationAgentTokenReplacedPayloadSchema = z.object({
  newTokenId: z.uuid(),
  replacedTokenId: z.uuid(),
  endedOverlapTokenId: z.uuid().nullable(),
  permissions: z.array(ValuationAgentPermissionSchema),
  // The replaced token's overlap end.
  validUntil: z.iso.datetime(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type ValuationAgentTokenReplacedPayload = z.infer<typeof ValuationAgentTokenReplacedPayloadSchema>;
